import { AppStateType } from '../types';
import { createSelector } from 'reselect';

export const getAuthSelector = (state: AppStateType) => {
  return state.auth;
};

export const getAuthErrorSelector = createSelector(
  getAuthSelector,
  (auth) => auth.error,
);

export const getIsUserLoggedInWhileRegisteringSelector = createSelector(
  getAuthSelector,
  (auth) => auth.loggedIn && auth.isUserRegistering,
);

export const getIsUserLoggedInSelector = createSelector(
  getAuthSelector,
  (auth) => auth.loggedIn && !auth.isUserRegistering,
);

export const getAuthOperationStatusSelector = createSelector(
  getAuthSelector,
  (auth) => auth.status,
);
export const currentLoginTokenSelector = createSelector(
  getAuthSelector,
  (accountInfo) => accountInfo?.loginToken,
);

export const getUserSelector = createSelector(
  getAuthSelector,
  (auth) => auth.user,
);

export const getUserAccessTokenSelector = createSelector(
  getUserSelector,
  (user) => user.token,
);

export const decodedUserTokenSelector = createSelector(
  getUserSelector,
  (user) => user.decoded,
);

export const decodedUserCountrySelector = createSelector(
  decodedUserTokenSelector,
  (decoded) => decoded.country,
);

export const decodedUserLanguageCodeSelector = createSelector(
  decodedUserTokenSelector,
  (decoded) => decoded.language,
);

export const currentUserUuidSelector = createSelector(
  decodedUserTokenSelector,
  (decoded) => decoded.uuid,
);

export const accountInfoSelector = createSelector(
  getAuthSelector,
  (auth) => auth.accountInfo,
);

export const userInfoSelector = createSelector(
  getAuthSelector,
  (auth) => auth.userInfo,
);

export const isUserEmailVerifiedSelector = createSelector(
  userInfoSelector,
  (userInfo) => userInfo?.['isEmailVerified'],
);

export const currentUserFirstNameSelector = createSelector(
  accountInfoSelector,
  (accountInfo) => accountInfo?.profile?.firstName,
);

export const currentUserLastNameSelector = createSelector(
  accountInfoSelector,
  (accountInfo) => accountInfo?.profile?.lastName,
);

export const currentUserEmailSelector = createSelector(
  accountInfoSelector,
  (accountInfo) => accountInfo?.profile?.email,
);

export const currentUserFullNameSelector = createSelector(
  currentUserFirstNameSelector,
  currentUserLastNameSelector,
  (name, lastName) => `${name} ${lastName}`,
);
